module.exports = __webpack_public_path__ + "static/media/testInsights.b52aefe6.svg";